export default "__VITE_ASSET__LfZNy1NP__"